'use client';

import type { PropsWithChildren } from 'react';
import type { Collection } from '@/app/actions/collection';
import type { InteractionType } from '~/model/InteractionType';
import type { SportType } from '~/model/SportType';
import { CrossSell, CrossSellWrapper } from '@/app/[locale]/(form)/components/CrossSell';
import { PendingCriteria } from './Criteria/PendingCriteria';
import { SorryPage } from './SorryPage/SorryPage';

export const CriteriaWrapper = ({
  children,
  interaction,
  sports,
}: PropsWithChildren<{
  interaction: InteractionType;
  sports: Collection<SportType>;
}>) => {
  const { user_status, criterion_status } = interaction.current_user_interaction_status;

  if (user_status === 'MISMATCH') {
    return (
      <SorryPage interaction={interaction} mismatched={criterion_status.mismatched}>
        <CrossSellWrapper>
          <CrossSell projectId={interaction.project.id} />
        </CrossSellWrapper>
      </SorryPage>
    );
  }

  return (
    <PendingCriteria sports={sports}>
      {children}
    </PendingCriteria>
  );
};
